import { TestResultDataType } from "../../rule-engine-core/Common/Testing/TestResultDataType";
import { ExpressionBuilder } from "../../Expressions/ExpressionBuilder";
import { ObserveState } from "../StateManagement/ObserveState";
import ReactDiffViewer from "react-diff-viewer-continued";
import { FormTestResult, FormUI } from "../../Form/Structure/FormTestResult";
import React from "react";
import { TextMergeTestResult } from "../../rule-engine-core/TextMerge/TextMergeTestResult";
import { ExpressionTestResult } from "../../rule-engine-core/Expressions/ExpressionTestResult";
import { IntersectionRuleDesigner } from "../../Rule/Intersection/Builder/IntersectionRuleDesigner";
import { IntersectionRuleTestResult } from "../../rule-engine-core/Rule/Intersection/IntersectionRuleTestResult";
import { RuleTableDesigner } from "../../Rule/Table/RuleTable/Builder/RuleTableDesigner";
import { RuleTableTestResult } from "../../rule-engine-core/Rule/Table/Rule/RuleTableTestResult";
import { ValueTableRuleDesigner } from "../../Rule/Table/ValueTable/Builder/ValueTableRuleDesigner";
import { ValueTableTestResult } from "../../rule-engine-core/Rule/Table/Value/ValueTableTestResult";
import { TreeRuleDesigner } from "../../Rule/Tree/Builder/TreeRuleDesigner";
import { TreeRuleTestResult } from "../../rule-engine-core/Rule/Tree/Structure/TreeRuleTestResult";
import { ITestResultItem } from "../../rule-engine-core/Common/Testing/ITestResultItem";
import { FlowDesignPage } from "../../Flow/Builder/Components/XFlowEditor.Designer";
import { FlowEditContext } from "../../Flow/FlowEditContext";
import { Box } from "@mui/material";
import { FlowTestContext } from "../../rule-engine-core/Flow/Structure/FlowTestingContext";
import { RenderTestResult, RenderTestResultWithFields } from "../../TextMerge/Utilities/TextMergeRenderTestResults";

export class TestDisplayFactory {
    static renderTestDisplay(resultItem: ITestResultItem): JSX.Element | undefined {
        switch (resultItem.type) {
            case TestResultDataType.FLOW:
                let editContext = new FlowEditContext((resultItem as FlowTestContext).flowConfiguration);
                return (
                    <Box height={"100%"}>
                        <FlowDesignPage
                            flow={(resultItem as FlowTestContext).flowConfiguration}
                            editContext={editContext}
                        />
                    </Box>
                );
            case TestResultDataType.FLOW_STEP:
                return <Box>step ui</Box>;
            case TestResultDataType.FLOW_SEQUENCE:
                break;
            case TestResultDataType.FLOW_BRANCH:
                break;

            case TestResultDataType.FORM:
                return <>{(resultItem as FormTestResult).form.render()}</>;
            case TestResultDataType.EXPRESSION:
                return <ExpressionBuilder expression={(resultItem as ExpressionTestResult).expression} />;
            case TestResultDataType.EXPRESSION_VALUE:
                break;
            case TestResultDataType.EXPRESSION_ELEMENT:
                break;
            case TestResultDataType.STATEMENT_RULE:
                break;
            case TestResultDataType.VALUE_TABLE_RULE:
                return (resultItem as ValueTableTestResult).definition &&
                    (resultItem as ValueTableTestResult).editContext ? (
                    <ValueTableRuleDesigner
                        ruleDefinition={(resultItem as ValueTableTestResult).definition!}
                        editContext={(resultItem as ValueTableTestResult).editContext!}
                    />
                ) : undefined;
            case TestResultDataType.VALUE_TABLE_RULE_ROW:
                break;
            case TestResultDataType.VALUE_TABLE_RULE_RULE_COLUMN:
                break;
            case TestResultDataType.RULE_TABLE:
                return (resultItem as RuleTableTestResult).definition &&
                    (resultItem as RuleTableTestResult).editContext ? (
                    <RuleTableDesigner
                        ruleDefinition={(resultItem as RuleTableTestResult).definition!}
                        editContext={(resultItem as RuleTableTestResult).editContext!}
                    />
                ) : undefined;
            case TestResultDataType.RULE_TABLE_ROW:
                break;
            case TestResultDataType.RULE_TABLE_COLUMN:
                break;
            case TestResultDataType.INTERSECTION_RULE:
                return (resultItem as IntersectionRuleTestResult).definition &&
                    (resultItem as IntersectionRuleTestResult).editContext ? (
                    <IntersectionRuleDesigner
                        ruleDefinition={(resultItem as IntersectionRuleTestResult).definition!}
                        editContext={(resultItem as IntersectionRuleTestResult).editContext!}
                    />
                ) : undefined;
            case TestResultDataType.INTERSECTION_X_RULE:
                break;
            case TestResultDataType.INTERSECTION_Y_RULE:
                break;
            case TestResultDataType.TREE_RULE:
                return (resultItem as TreeRuleTestResult).definition &&
                    (resultItem as TreeRuleTestResult).editContext ? (
                    <TreeRuleDesigner
                        ruleDefinition={(resultItem as TreeRuleTestResult).definition!}
                        editContext={(resultItem as TreeRuleTestResult).editContext!}
                    />
                ) : undefined;
            case TestResultDataType.TREE_NODE_RULE:
                break;
            case TestResultDataType.TEXT_MERGE:
                return <RenderTestResult definition={(resultItem as TextMergeTestResult).definition!} />;
            case TestResultDataType.TEXT_MERGE_VALUE:
                break;
        }

        return undefined;
    }

    static renderTabs(resultItem: ITestResultItem): { name: string; ui: JSX.Element }[] | undefined {
        switch (resultItem.type) {
            case TestResultDataType.FLOW:
                break;
            case TestResultDataType.FLOW_STEP:
                break;
            case TestResultDataType.FLOW_SEQUENCE:
                break;
            case TestResultDataType.FLOW_BRANCH:
                break;
            case TestResultDataType.FORM:
                return [
                    {
                        name: "ui",
                        ui: (
                            <FormUI
                                renderUI={(resultItem as FormTestResult).form.render}
                                context={(resultItem as FormTestResult).formContext}
                            />
                        ),
                    },
                    {
                        name: "compare",
                        ui: (
                            <ObserveState
                                listenTo={this}
                                control={() => (
                                    <ReactDiffViewer
                                        oldValue={JSON.stringify(
                                            (resultItem as FormTestResult).startData.values,
                                            null,
                                            2,
                                        )}
                                        newValue={JSON.stringify(
                                            (resultItem as FormTestResult).formContext.data.values,
                                            null,
                                            2,
                                        )}
                                    />
                                )}
                            />
                        ),
                    },
                ];
            case TestResultDataType.EXPRESSION:
                break;
            case TestResultDataType.EXPRESSION_VALUE:
                break;
            case TestResultDataType.EXPRESSION_ELEMENT:
                break;
            case TestResultDataType.STATEMENT_RULE:
                break;
            case TestResultDataType.VALUE_TABLE_RULE:
                break;
            case TestResultDataType.VALUE_TABLE_RULE_ROW:
                break;
            case TestResultDataType.VALUE_TABLE_RULE_RULE_COLUMN:
                break;
            case TestResultDataType.RULE_TABLE:
                break;
            case TestResultDataType.RULE_TABLE_ROW:
                break;
            case TestResultDataType.RULE_TABLE_COLUMN:
                break;
            case TestResultDataType.INTERSECTION_RULE:
                break;
            case TestResultDataType.INTERSECTION_X_RULE:
                break;
            case TestResultDataType.INTERSECTION_Y_RULE:
                break;
            case TestResultDataType.TREE_RULE:
                break;
            case TestResultDataType.TREE_NODE_RULE:
                break;
            case TestResultDataType.TEXT_MERGE:
                return [
                    {
                        name: "result",
                        ui: <RenderTestResult definition={(resultItem as TextMergeTestResult).definition!} />,
                    },
                    {
                        name: "result [fields]",
                        ui: <RenderTestResultWithFields definition={(resultItem as TextMergeTestResult).definition!} />,
                    },
                ];
                break;
            case TestResultDataType.TEXT_MERGE_VALUE:
                break;
        }

        return undefined;
    }
}
